<script>
    import { onMount } from 'svelte';
    import { PanelLeftClose, PanelLeftOpen } from 'lucide-svelte';

    let collapsed = $state(false);
    onMount(() => {
        try { collapsed = localStorage.getItem('desktop-sidebar-collapsed') === 'true'; } catch { /* 저장이 차단돼도 토글은 동작한다. */ }
    });
    function toggle() {
        collapsed = !collapsed;
        try { localStorage.setItem('desktop-sidebar-collapsed', String(collapsed)); } catch { /* 현재 화면의 상태만 유지한다. */ }
    }
</script>

<button class="sidebar-toggle textButton" type="button" aria-label={collapsed ? '메뉴 펼치기' : '메뉴 접기'} title={collapsed ? '메뉴 펼치기' : '메뉴 접기'} aria-expanded={!collapsed} aria-controls="sidebar-navigation sidebar-account" onclick={toggle}>
    {#if collapsed}<PanelLeftOpen size={18} />{:else}<PanelLeftClose size={18} />{/if}
</button>
